/**
 * Historical Significance List Component
 * Displays a list of historical significance items
 * Follows Single Responsibility Principle - only responsible for rendering the list
 */

import React from 'react';
import { spacing } from '@/design-system/utils';
import { HistoricalSignificanceItem } from './HistoricalSignificanceItem';
import { HistoricalSignificanceItemData } from './types';

export interface HistoricalSignificanceListProps {
  /**
   * Array of historical significance items to display
   */
  items: HistoricalSignificanceItemData[];
}

/**
 * Historical Significance List Component
 * Renders a vertical list of historical significance items
 */
export const HistoricalSignificanceList: React.FC<
  HistoricalSignificanceListProps
> = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[3],
      }}
    >
      {items.map(item => (
        <HistoricalSignificanceItem key={item.id} item={item} />
      ))}
    </div>
  );
};
